import styled from 'styled-components';
import { textStyles, token } from '@bynder/design-system';

export const OverviewCount = styled.div`
    ${textStyles.uiTextS}
    color: ${token.gray600};
    padding: 0 ${token.spacing2} ${token.spacing4};
`;
